import { useMemo } from 'react'
import { Box, Table } from '@mantine/core'

import { TableList } from '@/modules/employerAdvisors/pages/components/TableList/TableList'
import { TableTitle } from '@/modules/employerAdvisors/pages/components/TableTitle/TableTitle'

import { Loader } from '@/components/Loader/Loader'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'

import { useEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisors } from '@/__generated__/queries'

import classes from './AdvisorsTable.module.css'

export function AdvisorsTable() {
  const { data, isFetching, isLoading } =
    useEmployerAdvisorsServiceEmployerAdvisorControllerGetAllAdvisors()

  const advisors = useMemo(() => {
    if (!data) {
      return []
    }

    return data
  }, [data])

  if (isFetching || isLoading) {
    return <Loader isMinimized />
  }

  return (
    <Box className={classes.table}>
      <ScrollArea scrollbars="x">
        <Table>
          {!!advisors.length && <TableTitle />}
          <TableList items={advisors} />
        </Table>
      </ScrollArea>
    </Box>
  )
}
